import { useSiteTraits } from '@confluence/targeting/entry-points/useSiteTraits.ts';

export const HIGH_TOUCH_TWC_SIGNUP_TRAIT = 'is_high_touch_twc_signup';

export type UseIsHighTouchTwcSignupResult = {
	/** true = high-touch, false = low-touch, null = trait not available. */
	isHighTouch: boolean | null;
	loading: boolean;
	error: Error | null;
};

export function useIsHighTouchTwcSignup(): UseIsHighTouchTwcSignupResult {
	// Meeting-signal routing consumes the TAP context already bootstrapped by Confluence. It must
	// not introduce an ungated trait request of its own on every attach point.
	const { data, loading, error } = useSiteTraits({ skipBootstrap: true });
	const traitValue = data?.attributes?.find(
		(attribute) => attribute.name === HIGH_TOUCH_TWC_SIGNUP_TRAIT,
	)?.value;

	return {
		isHighTouch: traitValue === undefined ? null : Boolean(traitValue) === true,
		loading,
		error,
	};
}
